import { fromJS, List } from 'immutable';
import queryString from 'query-string';
import { updateLocation, pureFilter } from '../../utils/urls';
import { getFavoritesStatistic } from '../../utils/section';
import api from '../../apiSingleton';

import { FAVORITES_LOAD, FILTER_RESET, FILTER_UPDATE, FAVORITE_STATISTIC } from './actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';
import GtagBuilder from '../../classes/builder/gtagEventBuilder';
import {
  gtagPushEventNewPage
} from '../../utils/googleAnalytics';

export function fetchFavorites ({ location }) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.getIn(['user', 'data', 'id'])) {
      return dispatch({
        type: FAVORITES_LOAD + ERROR,
        payload: 'пользователь не авторизован'
      });
    }

    const statistic = state.getIn(['user', 'data', 'favoritesStatistics'], new List()).toJS();
    const defaultRubric = getFavoritesStatistic(statistic, true);

    const params = fromJS(location);

    const dealTypeUrl = params.getIn(['params', 'dealType']);
    const realtyTypeUrl = params.getIn(['params', 'realtyType']);

    const isFavorites = defaultRubric.filter(tab => tab[3] === dealTypeUrl && tab[4] === realtyTypeUrl).length;

    const dealType = isFavorites ? dealTypeUrl : (defaultRubric.length ? defaultRubric[0][3] : null);
    const realtyType = isFavorites ? realtyTypeUrl : (defaultRubric.length ? defaultRubric[0][4] : null);

    if (!dealType || !realtyType) {
      return dispatch({
        type: FAVORITES_LOAD + ERROR,
        payload: 'нет избранного'
      });
    }

    const filter = pureFilter(state.getIn(['favorites', 'filter'])).toJS();
    return dispatch(loadFavorites(dealType, realtyType, filter));
  };
}

export function loadFavorites (dealType, realtyType, filter) {
  return (dispatch, getState) => {
    dispatch({
      type: FAVORITES_LOAD + START
    });

    const user = getState().get('user');

    const params = Object.assign({}, filter, {expand: 'object'});

    return api.user
      .favorites(user.getIn(['data', 'id']), dealType, realtyType, params, user.get('token'))
      .then(data => {
        const domain = getState().get('domain');
        const meta = fromJS(data._meta);
        const cianGtagEvent = new GtagBuilder({})
          .setEvent('newpage')
          .setEventCategory('page')
          .setEventAction('newpage')
          .setEventLabel('open')
          .setUser(user)
          .setPage({
            pageType: 'ListingFavorites',
            siteType: 'desktop',
            listingType: 'list',
            sortType: 'default',
            offersQty: meta.get('totalCount'),
            pageNumber: Number(meta.get('currentPage'))
          })
          .setProducts(fromJS(data.items).map(v => v.get('object')))
          .getEvent();
        gtagPushEventNewPage(cianGtagEvent);
        dispatch({
          type: FAVORITES_LOAD + SUCCESS,
          items: fromJS(data.items),
          meta: fromJS(data._meta)
        });
      })
      .catch(err => dispatch({
        type: FAVORITES_LOAD + ERROR,
        payload: err.message
      }));
  };
}

export function updateStatistic (statistic) {
  return {
    type: FAVORITE_STATISTIC + SUCCESS,
    payload: statistic
  };
}

/**
 * Сбросить фильтр на дефолтный
 * @returns {{type}}
 */
export function resetFilter () {
  return (dispatch, getState) => {
    dispatch({
      type: FILTER_RESET
    });

    return updateLocation('favorites', getState(), dispatch);
  };
}

/**
 * Обновить фильтр и перейти на новый адрес
 * @param filter
 * @returns {function(*, *)}
 */
export function updateFilter (filter) {
  return (dispatch, getState) => {
    dispatch({
      type: FILTER_UPDATE,
      payload: fromJS(filter)
    });

    return updateLocation('favorites', getState(), dispatch);
  };
}

/**
 * Вызывает action для установки нового фильтра при смене URL
 * @param location
 * @returns {function(*, *)}
 */
export function setFilterByLocation ({ location }) {
  return (dispatch, getState) => {
    const state = getState();
    const filterFromState = state.getIn(['favorites', 'filter']);
    const filterFromLocation = queryString.parse(location.search);

    return dispatch(updateFilter({...(filterFromState ? filterFromState.toJS() : {}), ...filterFromLocation}));
  };
}



// WEBPACK FOOTER //
// ./src/app/Favorites/actions.js